export const trackingEvents = {
  SAVE: {
    CLICKED: 'employer_salesforce.save.clicked',
  },
}
